import React from "react";
import { FastField } from "formik";

import { NumberField } from "../../../../../../elements/FormField";
import { numberValidator } from "../../../../../../utils/formValidators";

const FillHeight = ({ prefix }) => (
  <FastField
    component={NumberField}
    name={`${prefix}.fillHeight`}
    validate={numberValidator({ min: 0, max: 100000 })}
    min={0}
    max={100000}
  />
);

export default FillHeight;
